var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrewAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7849 17.9733C9.69399 16.9938 8.67731 15.7324 7.87929 14.5569C7.40021 13.8512 6.98977 13.1614 6.68147 12.5604L4.68311 14.5588C4.7485 14.7686 4.88181 15.0935 5.09984 15.5198C5.37632 16.0604 5.75636 16.7018 6.20976 17.3697C6.88529 18.3648 7.70114 19.3855 8.55005 20.2081L10.7849 17.9733Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18624 21.5417C6.24847 20.6273 5.38138 19.5314 4.68216 18.5014C4.1992 17.79 3.78601 17.0948 3.47688 16.4904C3.3925 16.3254 3.31288 16.1615 3.24042 16.0015L2.61766 16.6242C2.37924 16.8626 2.23414 17.1748 2.21427 17.4921L2.00238 20.8761C1.96101 21.5369 2.46312 22.039 3.12389 21.9976L6.50786 21.7857C6.74663 21.7708 6.98251 21.6849 7.18624 21.5417Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89097 2.83461C8.55066 1.17492 14.2185 1.89798 18.1603 5.83974C22.102 9.7815 22.8251 15.4493 21.1654 17.109C19.8569 18.4174 16.7577 17.5445 13.5731 15.185L12.135 16.6231C11.1487 15.7509 10.1848 14.5711 9.4068 13.4252C8.95341 12.7573 8.57337 12.1158 8.29689 11.5753C8.21745 11.4199 8.14925 11.2781 8.09149 11.1503L8.81496 10.4269C6.45544 7.24227 5.58252 4.14306 6.89097 2.83461Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewAlt);
export default __webpack_public_path__ + "static/media/screw-alt.045ce37df38f30b2d7138c0194a668f7.svg";
export { ForwardRef as ReactComponent };